'use client';

import BrandsPageContext from '@/context/BrandsPageContext';
import { apiClient } from '@/services/base';
import { BrandCode, PageIds } from '@/types/algonomy';
import { FC, PropsWithChildren, useEffect } from 'react';
import { BrandsContextContainerProps } from './types';

const BrandsContextContainer: FC<PropsWithChildren<BrandsContextContainerProps>> = ({ children }) => {
  const sendBrandsPage = async () => {
    try {
      const urlParams = new URLSearchParams({
        brandCode: BrandCode.PYR,
        placements: PageIds.IndividualBrand,
      });
      await apiClient.get(`/recsForPlacements?${urlParams}`);
    } catch (error) {
      console.log('error while sending brands page data', error);
    }
  };
  useEffect(() => {
    sendBrandsPage();
  }, []);

  const onSelectBrandLetter = (el: React.MouseEvent<HTMLElement>) => {
    const target = el.target as HTMLElement;
    if (target.hasAttribute('data-letter')) {
      const dataLetter = target.getAttribute('data-letter') ?? '';
      const idLetterElement = document?.querySelector<HTMLElement>(`#${dataLetter}`);
      if (idLetterElement) {
        window.scrollTo({
          top: idLetterElement.offsetTop - 80,
          behavior: 'smooth',
        });
      }
    }
  };

  return <BrandsPageContext.Provider value={{ onSelectBrandLetter }}>{children}</BrandsPageContext.Provider>;
};

export default BrandsContextContainer;
